<template>
    <div class="mit-maps-page mit-page">
        <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card">
              <v-card-title>Edit Building {{$route.params.buildingMitId}}</v-card-title>
              <v-card-subtitle class="caption">Add, edit or delete objects on the maps</v-card-subtitle>
              <v-divider></v-divider>

              <v-card-text>
                  <MitSpacesMap :buildingMitId="$route.params.buildingMitId" :editMode="true"/>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
    import MitSpacesMap from '../../components/MitSpacesMap.vue';


  export default {
    name: 'MitAdminSpacesObjectsDrawPage',
    components: {
        MitSpacesMap
    },
    data: function() {
      return {

      }
  },
    created(){

    },
    methods : {
    }
  }
</script>

<style lang="scss" scoped>
.mit-info-card {
  width:100%;
  height:100%;
}
</style>
